import { create } from 'zustand';

export interface Toast {
  id: number;
  kind: 'error' | 'success' | 'info';
  message: string;
}

interface ToastState {
  toasts: Toast[];
  push(kind: Toast['kind'], message: string): void;
  dismiss(id: number): void;
}

let seq = 1;

export const useToasts = create<ToastState>((set) => ({
  toasts: [],
  push(kind, message) {
    const id = seq++;
    set((s) => ({ toasts: [...s.toasts.slice(-4), { id, kind, message }] }));
    setTimeout(() => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })), kind === 'error' ? 7000 : 3500);
  },
  dismiss(id) {
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
  },
}));

export const toast = {
  error: (m: string) => useToasts.getState().push('error', m),
  success: (m: string) => useToasts.getState().push('success', m),
  info: (m: string) => useToasts.getState().push('info', m),
};

export function errorMessage(e: unknown): string {
  if (e instanceof Error) return e.message.replace(/^.*?SenderError:\s*/, '');
  return String(e);
}

/** Runs an async action, surfacing failures as toasts. Resolves to success. */
export async function attempt(fn: () => Promise<unknown>, success?: string): Promise<boolean> {
  try {
    await fn();
    if (success) toast.success(success);
    return true;
  } catch (e) {
    toast.error(errorMessage(e));
    return false;
  }
}
